// Console logları için basit bir yardımcı
export const log = (...args) => {
  console.log('[DEBUG]', new Date().toISOString(), ...args);
};

export const error = (...args) => {
  console.error('[ERROR]', new Date().toISOString(), ...args);
};

export const warn = (...args) => {
  console.warn('[WARN]', new Date().toISOString(), ...args);
};
